import request from '@/utils/request';

// post /api/v1/admin/game_config/game_category/create 创建游戏标签分类
export function createGameCategory(data) {
  return request({
    url: '/api/v1/admin/game_config/game_category/create',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_category/change_status 修改游戏标签分类状态
export function changeGameCategoryStatus(data) {
  return request({
    url: '/api/v1/admin/game_config/game_category/change_status',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_category/delete 删除游戏标签分类
export function deleteGameCategory(data) {
  return request({
    url: '/api/v1/admin/game_config/game_category/delete',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_category/get 获取游戏标签分类详情
export function getGameCategory(data) {
  return request({
    url: '/api/v1/admin/game_config/game_category/get',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_category/list 获取游戏标签分类列表
export function listGameCategory(data) {
  return request({
    url: '/api/v1/admin/game_config/game_category/list',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_category/update 更新游戏标签分类
export function updateGameCategory(data) {
  return request({
    url: '/api/v1/admin/game_config/game_category/update',
    method: 'post',
    mock: false,
    data
  })
}
